import React, { useEffect, useState } from "react";
import {
  Form,
  Input,
  Select,
  Button,
  Row,
  Col,
  Spin,
  Card,
  InputNumber,
} from "antd";
import useFirmService from "../../../services/useFirmService";
import useAuth from "../../../hooks/useAuth";
import useCommonsService from "../../../services/useCommonsService";
import FirmImage from "./Components/FirmImage";
import LocationPicker from "../CreateEditAdvert/Components/LocationPicker";

const FirmProfile = () => {
  const [form] = Form.useForm();
  const { firmAuth } = useAuth();
  const [selectedCityId, setSelectedCityId] = useState(
    firmAuth.user.firm.district.city.id
  );
  const [locationData, setLocationData] = useState({
    latitude: null,
    longitude: null,
    address: "",
  });

  const { cities, isGetCitiesLoading, useDistricts } = useCommonsService();
  const { data: districts, isPending: isLoadingDistricts } =
    useDistricts(selectedCityId);

  const { useUpdateFirm, useGetFirm } = useFirmService();
  const { mutateAsync: updateFirm } = useUpdateFirm();
  const { data: firm } = useGetFirm();

  const handleCityChange = (value) => {
    setSelectedCityId(value);
    form.setFieldValue("district", undefined);
  };

  const handleLocationChange = (newLocation) => {
    setLocationData(newLocation);
    form.setFieldsValue({
      location: newLocation,
      address: newLocation.address,
    });
  };

  useEffect(() => {
    if (!firm) {
      return;
    }

    // Set initial location data
    const initialLocation = {
      latitude: firm.data.firmAddress?.coordinate?.latitude || null,
      longitude: firm.data.firmAddress?.coordinate?.longitude || null,
      address: firm.data.firmAddress?.address || "",
    };
    setLocationData(initialLocation);

    form.setFieldsValue({
      ...firm.data,
      district: firm.data.district.id,
      city: firm.data.district.city.id,
      location: initialLocation,
      address: firm.data.firmAddress.address,
    });
  }, [firm]);

  const onFinish = (values) => {
    const requestBody = {
      companyName: values.companyName,
      taxNo: values.taxNo,
      taxOffice: values.taxOffice,
      districtId: values.district,
      status: firmAuth.user.firm.status,
      address: values.location.address,
      latitude: values.location.latitude,
      longitude: values.location.longitude,
      companyPhoneNumber: values.companyPhoneNumber.toString(),
      firmSignatories: values.firmSignatories,
    };
    updateFirm(requestBody);
  };

  return (
    <>
      <Spin spinning={isLoadingDistricts || isGetCitiesLoading}>
        <Card title="Firma Bilgileri Güncelleme Formu">
          <Form
            form={form}
            layout="vertical"
            onFinish={onFinish}
            style={{ maxWidth: 1000, margin: "0 auto" }}>
            <Row gutter={16}>
              <Col span={12}>
                <Form.Item
                  name="companyName"
                  label="Şirket Adı:"
                  rules={[
                    { required: true, message: "Lütfen Şirket adını giriniz" },
                  ]}>
                  <Input />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  name="taxNo"
                  label="VKN:"
                  rules={[{ required: true, message: "Lütfen VKN giriniz" }]}>
                  <Input />
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={16}>
              <Col span={12}>
                <Form.Item
                  name="taxOffice"
                  label="Vergi Dairesi"
                  rules={[
                    {
                      required: true,
                      message: "Lütfen geçerli bir Vergi Dairesi giriniz",
                    },
                  ]}>
                  <Input />
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={[16, 16]}>
              <Col xs={24} md={12}>
                <Form.Item
                  label="Şehir"
                  name="city"
                  rules={[
                    {
                      required: true,
                      message: "Lütfen Şehir seçiniz",
                    },
                  ]}>
                  <Select
                    loading={isGetCitiesLoading}
                    options={cities}
                    placeholder="Şehir"
                    onChange={handleCityChange}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} md={12}>
                <Form.Item
                  label="İlçe"
                  name="district"
                  rules={[
                    {
                      required: true,
                      message: "Lütfen İlçe seçiniz",
                    },
                  ]}>
                  <Select
                    loading={isLoadingDistricts}
                    options={districts}
                    placeholder="İlçe"
                    disabled={!selectedCityId}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={8}>
              <Col md={12} xs={24}>
                <Form.Item
                  label="İmza Yetkilileri (İsimleri tek tek girip enter tuşuna basınız)"
                  name="firmSignatories"
                  rules={[
                    {
                      required: true,
                      message: "Lütfen imza yetkililerini giriniz",
                    },
                  ]}>
                  <Select mode="tags" placeholder="İmza Yetkilileri" />
                </Form.Item>
              </Col>
              <Col md={12} xs={24}>
                <Form.Item
                  label="Şirket Telefon Numarası"
                  name="companyPhoneNumber"
                  rules={[
                    {
                      required: true,
                      message: "Lütfen şirket telefon numarasını giriniz",
                    },
                  ]}>
                  <InputNumber
                    style={{ width: "100%" }}
                    placeholder="Şirket Telefon Numarası"
                  />
                </Form.Item>
              </Col>
            </Row>

            <Form.Item
              label="Konum"
              name="location"
              rules={[{ required: true, message: "Lütfen konum seçiniz" }]}>
              <LocationPicker
                value={locationData}
                onChange={handleLocationChange}
                isAdvertCreateOrEdit={false}
                initialLocation={locationData}
              />
            </Form.Item>

            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                style={{
                  width: "100%",
                  height: "40px",
                  borderColor: "#5f9ea0",
                }}>
                BİLGİLERİMİ GÜNCELLE
              </Button>
            </Form.Item>
          </Form>
        </Card>
      </Spin>
      <FirmImage imageUrl={firm?.data?.imageUrl} />
    </>
  );
};

export default FirmProfile;
